import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import TechTrackingTable from './TechTrackingTable';

const DynamicAppTracking = () => {
    const { appId } = useParams();
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConfig = async () => {
            setLoading(true);
            try {
                const docRef = doc(db, 'tech_apps', appId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setConfig(docSnap.data());
                } else {
                    console.error("No such app configuration!");
                }
            } catch (error) {
                console.error("Error fetching app config:", error);
            }
            setLoading(false);
        };
        fetchConfig();
    }, [appId]);

    if (loading) return <div className="min-h-screen bg-neutral-900 text-white p-10 font-poppins">Loading App Configuration...</div>;

    if (!config) return <div className="min-h-screen bg-neutral-900 text-white p-10 font-poppins text-center flex flex-col items-center justify-center">
        <h1 className="text-2xl font-bold mb-4">App Not Found</h1>
        <p className="text-gray-400">The tracker for "{appId}" does not exist.</p>
    </div>;

    return (
        <TechTrackingTable
            appId={appId}
            config={config}
        />
    );
};

export default DynamicAppTracking;
